export function formatNumber(num) {
  return num.toLocaleString("de-DE");
}
